import { specialtyTypeFormatter } from '../services/utils/therapy-service';

export interface MedTag {
  text: string;
  description: string;
}

export class MedUtils {
  static getMedicationTags(
    therapySpecialtyType?: string,
    medSpecialtyType?: string,
    defaultTags: MedTag[] = [],
  ): MedTag[] {
    const types = (therapySpecialtyType || medSpecialtyType || '').split(',');
    const tags = [
      ...defaultTags,
      ...types.map(type => ({
        text: type,
        description: specialtyTypeFormatter(null, 'specialty_type', type),
      })),
    ];

    return tags;
  }

  static isMedicationGroupTreatedAsMedication(medicationGroup: any) {
    if (!medicationGroup) {
      return false;
    }
    const therapy = medicationGroup?.therapy;
    const linkedTherapyIsInactive = therapy
      ? [3, 4].includes(therapy?.administration_status_category_id)
      : false;
    const medicationIsActive = !!medicationGroup.active;
    return medicationIsActive && linkedTherapyIsInactive ? true : !therapy;
  }
}
